import { sodApi } from '@/services/index'
// Define a service using a base URL and expected endpoints
export const HRUploadApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    HRImportDocument: builder.mutation({
      query: ({ formData, engagementId }) => ({
        url: '/HRDocument/Upload/' + engagementId,
        method: 'POST',
        body: formData,
      }),
    }),
    deleteUploadedDocument: builder.query<any, any>({
      query: (hrDocumentId) => ({
        url: `/HRDocument/${hrDocumentId}/Cancel`,
        method: 'GET',
      }),
    }),
    HRConfirmDocument: builder.query({
      query: (hrDocumentId) => ({
        url: `/HRDocument/${hrDocumentId}/Confirm`,
        method: 'GET',
      }),
    }),
    listHRDocument: builder.query<any, any>({
      query: (engagementId) => ({
        url: '/HRDocument/List/' + engagementId,
        method: 'GET',
      }),
    }),
    activateHRDocument: builder.query({
      query: (documentId) => ({
        url: `/HRDocument/${documentId}/Activate`,
        method: 'GET',
      }),
    }),
    deactivateHRDocument: builder.query({
      query: (documentId) => ({
        url: `/HRDocument/${documentId}/Deactivate`,
        method: 'GET',
      }),
    }),
    getColumnList: builder.query<any, any>({
      query: (documentId) => ({
        url: `/HRDocument/${documentId}/ListColumns`,
        method: 'GET',
      }),
    }),
    saveColumnMapping: builder.mutation({
      query: ({ data, documentId }) => ({
        url: `/HRDocument/${documentId}/MapColumns`,
        method: 'POST',
        body: data,
      }),
    }),
    getHRIndexingStatus: builder.query<{ isIndexing: boolean }, string>({
      query: (engagementId) => ({
        url: `/HRDocument/${engagementId}/IndexingStatus`,
        method: 'GET',
      }),
    }),
  }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useHRImportDocumentMutation,
  useLazyDeleteUploadedDocumentQuery,
  useLazyHRConfirmDocumentQuery,
  useLazyListHRDocumentQuery,
  useLazyActivateHRDocumentQuery,
  useLazyDeactivateHRDocumentQuery,
  useGetColumnListQuery,
  useSaveColumnMappingMutation,
  useGetHRIndexingStatusQuery,
} = HRUploadApi
